// Mobile chart share (Mantis 0013106): while the share capture runs, the chart
// and its indicator panels are laid out to fill the export exactly as wide as
// the capture area.
//   - No indicator panels: square, 1080x1080.
//   - With indicator panels: 4:5, 1080x1350 - the tallest shape the feed shows
//     at full width - so the panels stay readable (in a square they were ~78px
//     each and too compact). The price chart keeps at least 55% of the height.
export const SHARE_EXPORT_WIDTH_PX = 1080;

export const shareExportHeight = (width, panelCount) =>
  panelCount ? Math.round((width * 5) / 4) : width;

export const squareExportPanelHeight = (height, panelCount, normal) =>
  panelCount ? Math.round(Math.min(normal, (height * 0.45) / panelCount)) : normal;
